// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem, IFormInstance } from '@/components';
import { Input, Switch } from '@/ui';
import { StyledFormContent } from './GoogleMerchantSettingsFormStyles';

// Helpers
import {
  MERCHANT_SETTINGS_FORM_ID,
  GoogleMerchantSettingsFormFields,
  TGoogleMerchantSettingsFormValues,
} from '../../helpers';
import { useMerchantSettingsFormRules } from '../../hooks';

type TMerchantSettingsFormProps = {
  form: IFormInstance;
  onSubmit: (values: TGoogleMerchantSettingsFormValues) => void;
  initialValues?: Partial<TGoogleMerchantSettingsFormValues>;
};

const MerchantSettingsForm: FC<TMerchantSettingsFormProps> = ({ initialValues, form, onSubmit }) => {
  const { t } = useTranslation(['common']);
  const rules = useMerchantSettingsFormRules();

  return (
    <Form id={MERCHANT_SETTINGS_FORM_ID} form={form} initialValues={initialValues} onFinish={onSubmit}>
      <StyledFormContent>
        <FormItem name={GoogleMerchantSettingsFormFields.ENABLED} label={t('merchant_settings_enabled_label')}>
          <Switch />
        </FormItem>
        <FormItem name={GoogleMerchantSettingsFormFields.DRY_RUN} label={t('merchant_settings_dry_run_label')}>
          <Switch />
        </FormItem>
        <FormItem
          rules={rules[GoogleMerchantSettingsFormFields.ACCOUNT_ID]}
          name={GoogleMerchantSettingsFormFields.ACCOUNT_ID}
          label={t('merchant_settings_account_id_label')}
        >
          <Input placeholder={t('merchant_settings_account_id_placeholder')} />
        </FormItem>
        <FormItem
          rules={rules[GoogleMerchantSettingsFormFields.DATA_SOURCE]}
          name={GoogleMerchantSettingsFormFields.DATA_SOURCE}
          label={t('merchant_settings_data_source_label')}
        >
          <Input placeholder={t('merchant_settings_data_source_placeholder')} />
        </FormItem>
        <FormItem
          rules={rules[GoogleMerchantSettingsFormFields.DEFAULT_CATEGORY_ID]}
          name={GoogleMerchantSettingsFormFields.DEFAULT_CATEGORY_ID}
          label={t('merchant_settings_default_category_id_label')}
        >
          <Input placeholder={t('merchant_settings_default_category_id_placeholder')} />
        </FormItem>
        <FormItem
          rules={rules[GoogleMerchantSettingsFormFields.FEED_LABEL]}
          name={GoogleMerchantSettingsFormFields.FEED_LABEL}
          label={t('merchant_settings_feed_label_label')}
        >
          <Input placeholder={t('merchant_settings_feed_label_placeholder')} />
        </FormItem>
        <FormItem
          rules={rules[GoogleMerchantSettingsFormFields.LANGUAGE]}
          name={GoogleMerchantSettingsFormFields.LANGUAGE}
          label={t('merchant_settings_language_label')}
        >
          <Input placeholder={t('merchant_settings_language_placeholder')} />
        </FormItem>
        <FormItem
          rules={rules[GoogleMerchantSettingsFormFields.CURRENCY]}
          name={GoogleMerchantSettingsFormFields.CURRENCY}
          label={t('merchant_settings_currency_label')}
        >
          <Input placeholder={t('merchant_settings_currency_placeholder')} />
        </FormItem>
        <FormItem
          name={GoogleMerchantSettingsFormFields.SEND_REPORT_EMAIL}
          label={t('merchant_settings_send_report_email_label')}
        >
          <Switch />
        </FormItem>
      </StyledFormContent>
    </Form>
  );
};

export default MerchantSettingsForm;
